import React from "react";
import { GTMEvent, GetCookie } from "../utils/utils";

export class JobForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      scriptLoaded: false,
      submitted: false
    };
  }

  scriptLoaded = () => {
    this.setState({ scriptLoaded: true });
  };

  loadGreenhouseScript = (scriptLoaded, job) => {
    if (scriptLoaded === false && job !== null) {
      const scriptNode = document.createElement("script");
      scriptNode.type = "text/javascript";
      scriptNode.src =
        "https://boards.greenhouse.io/embed/job_board/js?for=teampicnic";
      scriptNode.addEventListener("load", this.scriptLoaded);
      document.body.appendChild(scriptNode);
    }
  };

  componentDidMount() {
    this.loadGreenhouseScript(this.state.scriptLoaded, this.props.job);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.scriptLoaded === true && this.state.submitted === false) {
      // eslint-disable-next-line
      Grnhse.Iframe.load(this.props.job.gh_Id);

      window.addEventListener("message", message => {
        let iframeHeight = message.data;
        if (this.state.submitted === false && iframeHeight > 10000) {
          this.trackUserApplication();

          GTMEvent("form_submission", [
            {
              name: this.props.job.title,
              id: this.props.job.gh_Id
            }
          ]);
          this.setState({ submitted: true });
        }
      });
    }
  }

  trackUserApplication() {
    let jobId = this.props.job.internal_job_id;
    let lambdaFunctionURL =
      "https://l7xq6e6pv5.execute-api.eu-central-1.amazonaws.com/default/trackGHApplication";
    let gclid = GetCookie("gclid");
    let fbclid = GetCookie("fbclid");

    if (gclid === "" && fbclid === "") {
      return -1;
    }

    fetch(lambdaFunctionURL, {
      method: "POST",
      body: JSON.stringify({
        jobId: jobId,
        ids: {
          gclid: gclid,
          fbclid: fbclid
        }
      }),
      headers: {
        "Content-Type": "application/json"
      },
      mode: "no-cors"
    });

    return 1;
  }

  render() {
    return (
      <div
        id="grnhse_app"
        className={
          this.state.submitted ? "submission-form-shown" : "submission-form"
        }
      />
    );
  }
}
